import React, { useEffect, useState } from 'react';
import { Loader2, UserCheck, X } from 'lucide-react';
import { toast } from 'sonner';
import api from '../api';

// Office picks which nurses work this patient; those nurses then see and chart only their assigned patients
export const CaseloadModal = ({ patientId, patientName, onClose }) => {
  const [staff, setStaff] = useState([]);
  const [picked, setPicked] = useState([]);
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);
  useEffect(() => {
    api.get(`/caseload/patient/${patientId}`).then(r => { setStaff(r.data.staff); setPicked(r.data.assigned.map(a => a.staffId)); })
      .catch(e => toast.error(e.response?.data?.detail || 'Could not load nurses')).finally(() => setLoading(false));
  }, [patientId]);
  const toggle = (id) => setPicked(p => (p.includes(id) ? p.filter(x => x !== id) : [...p, id]));
  const save = async () => {
    setSaving(true);
    try { const r = await api.put('/caseload/patient', { patientId, staffIds: picked }); toast.success(r.data.message); onClose(); }
    catch (e) { toast.error(e.response?.data?.detail || 'Could not save'); } finally { setSaving(false); }
  };
  return (
    <div className="fixed inset-0 bg-black/60 flex items-center justify-center z-[100] p-4" data-testid="caseload-modal">
      <div className="bg-white rounded-xl shadow-2xl max-w-md w-full">
        <div className="bg-gray-900 p-4 rounded-t-xl flex items-center justify-between">
          <h3 className="text-lg font-bold text-[#d4af37] flex items-center gap-2"><UserCheck className="w-5 h-5" /> Assign Nurses</h3>
          <button onClick={onClose} className="text-white/80 hover:text-white" data-testid="caseload-close"><X className="w-5 h-5" /></button>
        </div>
        <div className="p-5 space-y-3">
          <p className="text-sm text-gray-600">Nurses ticked here can see and chart <strong>{patientName}</strong> for every visit type. They see only their own assigned patients.</p>
          {loading ? <Loader2 className="w-6 h-6 animate-spin mx-auto text-gray-400" /> : staff.length === 0
            ? <p className="text-sm text-amber-700 bg-amber-50 p-2 rounded" data-testid="caseload-no-staff">No nurse logins yet. Create one in Admin &gt; User / Security Manager with role Clinician.</p>
            : <div className="max-h-72 overflow-y-auto divide-y border rounded-lg">
              {staff.map(s => (
                <label key={s.id} className="flex items-center gap-3 p-2.5 cursor-pointer hover:bg-gray-50" data-testid={`caseload-staff-${s.id}`}>
                  <input type="checkbox" checked={picked.includes(s.id)} onChange={() => toggle(s.id)} className="w-4 h-4" />
                  <span className="flex-1 text-sm font-medium">{s.firstName} {s.lastName}<span className="block text-xs text-gray-500 font-normal">{s.role} · {s.email}</span></span>
                </label>
              ))}
            </div>}
          <button onClick={save} disabled={saving || loading} className="w-full py-2.5 rounded-full bg-[#d4af37] text-gray-900 font-semibold disabled:bg-gray-300 flex items-center justify-center gap-2" data-testid="caseload-save">
            {saving && <Loader2 className="w-4 h-4 animate-spin" />} Save Nurses
          </button>
        </div>
      </div>
    </div>
  );
};
